import { isEmpty } from 'lodash';
import { Cookies } from 'react-cookie';

import {
    CONTEST_COOKIE_PREFIX,
    CONTEST_MODAL_MAXIMUM_DISPLAY,
    CONTEST_END_COOKIE_PREFIX,
    CONTEST_END_MODAL_START_DATE,
    CONTEST_END_MODAL_MAXIMUM_DISPLAY,
    CONTEST_END_MODAL_END_DATE
} from './constants';

import { nowTimestamp, timestampPlusDays, toMoment, toTimestamp } from '../../utils/dateUtils';

// Contest
export const isContestActive = contest => {
    if (
        !contest ||
        isEmpty(contest) ||
        contest.id <= 0 ||
        contest.startDate <= 0 ||
        contest.endDate <= 0
    ) {
        return false;
    }

    const now = toMoment(nowTimestamp());
    const start = toMoment(contest.startDate);
    const end = toMoment(contest.endDate);

    return now.isAfter(start) && now.isBefore(end);
};

export const canShowContestModal = contest => {
    const cookie = getContestCookie(contest.id);
    const nbClose = (cookie && cookie.nbClose) || 0;
    const until = (cookie && cookie.until) || null;

    return (
        nbClose < CONTEST_MODAL_MAXIMUM_DISPLAY &&
        (!until || toMoment(nowTimestamp()).isAfter(toMoment(until)))
    );
};

export const handleContestCookie = contest => {
    const cookie = getContestCookie(contest.id);
    const nbClose = (cookie && cookie.nbClose) || 0;
    const until = (cookie && cookie.until) || null;
    const nextDay = timestampPlusDays(nowTimestamp(), 1);

    // Create cookie
    if (nbClose === 0 && !until) {
        const newUntil = CONTEST_MODAL_MAXIMUM_DISPLAY > 1 ? nextDay : contest.endDate;
        setContestCookie(contest, 1, newUntil);
    }

    // Update cookie if necessary
    if (nbClose > 0 && until) {
        if (nbClose + 1 < CONTEST_MODAL_MAXIMUM_DISPLAY) {
            setContestCookie(contest, nbClose + 1, nextDay);
        }
        if (nbClose + 1 === CONTEST_MODAL_MAXIMUM_DISPLAY) {
            setContestCookie(contest, nbClose + 1, contest.endDate);
        }
    }
};

const setContestCookie = (contest, nbClose, until) => {
    const cookies = new Cookies();

    const cookieValue = `nbClose=${nbClose}&until=${until}`;

    cookies.set(`${CONTEST_COOKIE_PREFIX}${contest.id}`, cookieValue, {
        path: '/',
        expires: toMoment(contest.endDate).toDate(),
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'strict'
    });
};

const getContestCookie = contestId => {
    const cookies = new Cookies();
    const cookie = cookies.get(`${CONTEST_COOKIE_PREFIX}${contestId}`);

    if (!cookie) return null;

    const params = new URLSearchParams(cookie);
    return {
        nbClose: parseInt(params.get('nbClose'), 10) || 0,
        until: parseInt(params.get('until'), 10) || 0
    };
};

// Contest end modal
export const canShowContestEndModal = () => {
    const cookie = getContestEndCookie();
    const nbClose = (cookie && cookie.nbClose) || 0;
    const until = (cookie && cookie.until) || null;

    return (
        toMoment(nowTimestamp()).isAfter(CONTEST_END_MODAL_START_DATE) &&
        toMoment(nowTimestamp()).isBefore(CONTEST_END_MODAL_END_DATE) &&
        nbClose < CONTEST_END_MODAL_MAXIMUM_DISPLAY &&
        (!until || toMoment(nowTimestamp()).isAfter(toMoment(until)))
    );
};

export const handleContestEndCookie = () => {
    const cookie = getContestEndCookie();
    const nbClose = (cookie && cookie.nbClose) || 0;
    const until = (cookie && cookie.until) || null;
    const nextDay = timestampPlusDays(nowTimestamp(), 1);

    // Create cookie
    if (nbClose === 0 && !until) {
        const newUntil =
            CONTEST_END_MODAL_MAXIMUM_DISPLAY > 1
                ? nextDay
                : toTimestamp(CONTEST_END_MODAL_END_DATE);
        setContestEndCookie(1, newUntil);
    }

    // Update cookie if necessary
    if (nbClose > 0 && until) {
        if (nbClose + 1 < CONTEST_END_MODAL_MAXIMUM_DISPLAY) {
            setContestEndCookie(nbClose + 1, nextDay);
        }
        if (nbClose + 1 === CONTEST_END_MODAL_MAXIMUM_DISPLAY) {
            setContestEndCookie(nbClose + 1, toTimestamp(CONTEST_END_MODAL_END_DATE));
        }
    }
};

const setContestEndCookie = (nbClose, until) => {
    const cookies = new Cookies();

    const cookieValue = `nbClose=${nbClose}&until=${until}`;

    cookies.set(`${CONTEST_END_COOKIE_PREFIX}`, cookieValue, {
        path: '/',
        expires: CONTEST_END_MODAL_END_DATE.toDate(),
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'strict'
    });
};

const getContestEndCookie = () => {
    const cookies = new Cookies();
    const cookie = cookies.get(`${CONTEST_END_COOKIE_PREFIX}`);

    if (!cookie) return null;

    const params = new URLSearchParams(cookie);
    return {
        nbClose: parseInt(params.get('nbClose'), 10) || 0,
        until: parseInt(params.get('until'), 10) || 0
    };
};



// WEBPACK FOOTER //
// ./src/services/giveaway/utils.js